module.exports = __webpack_public_path__ + "static/footer-7130e3775ad762be5662b0a576001c8b.jpg";